import { useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { useAuthBroker } from '@/common/auth/useAuthBroker'

const brokerBaseURL = import.meta.env.VITE_COVERX_BROKER_DASH
const brokerDashboardURL = brokerBaseURL + '/broker/dashboard'

export const BrokerRibbon = () => {
  const { t } = useTranslation()
  const email = useMemo(useAuthBroker, [])
  const returnDashboard = () => {
    sessionStorage.clear()
  }
  return (
    <div className="instantQuoteBrokerInfo">
      <div>
        <span>
          {t('common.ribbon1')}
          <strong> {t('common.ribbon_strong')}</strong>
          <Trans
            i18nKey={'common.ribbon_mail'}
            values={{ email: email }}
          ></Trans>
        </span>
        <a href={brokerDashboardURL} onClick={returnDashboard}>
          {t('common.return_dashboard')}
        </a>
      </div>
    </div>
  )
}
